import {
  AwaitContainer,
  Button,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  ScrollArea,
} from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DIALOG_CONTENT_SCREEN_BOUNDED, SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';

type Props = {
  isOpen: boolean;
  title: string;
  text: string;
  isLoading: boolean;
  /** Адрес перехода к открытому; пусто — перехода нет */
  linkPath?: string;
  onClose: () => void;
};

/**
 * Окно того, на что ссылается результат заключения, — правила или знания: название, текст
 * и переход туда, где открытое живёт.
 */
export const ReportReferenceDialog: FC<Props> = ({ isOpen, title, text, isLoading, linkPath, onClose }) => {
  const { t } = useTranslation(['dialogs']);
  return (
    <DialogRoot open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
      {/* Текст правила или знания бывает любой длины */}
      <DialogContent className={DIALOG_CONTENT_SCREEN_BOUNDED}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <ScrollArea orientation="vertical" className={SCROLL_AREA_VIEWPORT_BLOCK}>
          <AwaitContainer isLoading={isLoading}>
            <div className="whitespace-pre-wrap wrap-break-word text-sm">{text}</div>
          </AwaitContainer>
        </ScrollArea>
        <DialogFooter className="flex items-center">
          {linkPath && (
            <Link to={linkPath} className="text-primary underline text-sm hover:text-primary/80">
              {t('expertReport.openCard')}
            </Link>
          )}
          <Button variant="outline" onClick={onClose}>
            {t('expertReport.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
